const ORIGIN_URL_PROD = 'https://epassport.meituan.com';
const ORIGIN_URL_DEV = 'https://fepassport.sjst.test.sankuai.com';

const ORIGIN_URL = ['staging', 'production'].includes(process.env.NODE_ENV) ? ORIGIN_URL_PROD : ORIGIN_URL_DEV;

const BASE_URL = {
    // 登录
    LOGIN: '/portal/login',
    // 注册
    SIGNUP: '/portal/signup',
    // 找回密码
    RECOVER: '/portal/recover/password',
    // 找回账号
    RECOVER_ACCOUNT: '/portal/recover/account',
    // 修改密码
    EDITPASSWORD: '/portal/reset-password',
    // 换绑手机
    BINDPHONE: '/portal/bindphone',
};

const nodeEnv = process.env.NODE_ENV;
const continueUrl = {
    production: '/api/carrier/epassport/continue609',
    staging: '/api/carrier/epassport/continue367',
}[nodeEnv] || '/api/carrier/epassport/continue855';


const OPTION = {
    bg_source: 14,
    part_type: 0,
    service: 'com.sankuai.mall.fe.jiemoserver',
    continue: '',
    partner: 683,
    app: 226,
};

let LocationOrigin = window.location.origin;

if (!LocationOrigin) {
    LocationOrigin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
}

const extraOption = {
    LOGIN: {
        leftBottomLink: `${LocationOrigin}/signup.html`,
        rightBottomLink: `${LocationOrigin}/recover.html`,
        recoverAccountLink: `${LocationOrigin}/recoverAccount.html`,
    },
};

export function getLoginUrl() {
    const url = `${ORIGIN_URL}${BASE_URL.LOGIN}`;
    const params = {
        service: 'com.sankuai.mall.fe.jiemoserver',
        bgSource: 14,
        platform: 2,
        feconfig: 'com.sankuai.malljiemo.vss',
        continue: `${LocationOrigin}${continueUrl}`,
    };
        // eslint-disable-next-line
    return `${url}?${qs.stringify(params)}`;
}


export default function (type, customContinueUrl) {
    // eslint-disable-next-line
    return `${ORIGIN_URL}${BASE_URL[type]}?${qs.stringify({
        ...OPTION,
        continue: customContinueUrl || `${LocationOrigin}${continueUrl}`,
        ...(extraOption[type] || {}),
    })}`;
}
